import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/api";

export type Counts = {
  tasks?: number;
  drafts_ready?: number;
  awaiting_holly?: number;
  [k: string]: number | undefined;
};

/** Notification counts for the tasks bubble (polls every 30s like the legacy app). */
export function useCounts() {
  return useQuery({
    queryKey: ["counts"],
    queryFn: () => apiCall<Counts>("counts"),
    refetchInterval: 30_000,
  });
}

/** The split bubble label ported from updateNotificationCounts(). */
export function tasksBubbleLabel(c?: Counts): { label: string; zero: boolean } {
  const total = c?.tasks || 0;
  const drafts = c?.drafts_ready || 0;
  const holly = c?.awaiting_holly || 0;
  if (drafts > 0 || holly > 0) {
    const parts: string[] = [];
    if (drafts > 0) parts.push(drafts + " draft" + (drafts > 1 ? "s" : ""));
    if (holly > 0) parts.push(holly + " input");
    const otherCount = total - drafts - holly;
    if (otherCount > 0) parts.push(otherCount + " task" + (otherCount > 1 ? "s" : ""));
    return { label: parts.join(" | "), zero: total === 0 };
  }
  return { label: String(total), zero: total === 0 };
}
